import React from 'react';
import AboutPageBuilder from './AboutPageBuilder';

const ServicesPageBuilder = () => (
  <AboutPageBuilder
    endpoint="/admin/services-page"
    pageTitle="Services Builder"
    viewPath="/services"
    viewLabel="View Services"
    saveLabel="Save Services"
    loadErrorMessage="Failed to load Services layout."
    saveErrorMessage="Failed to save Services layout."
    saveSuccessMessage="Services page updated."
    loadingMessage="Loading Services editor..."
    unavailableMessage="Services layout unavailable."
  />
);

export default ServicesPageBuilder;
